(() => {
  const init = (root = document) => root.querySelectorAll('[data-tmo]').forEach((page) => {
    if (page.dataset.ready) return;
    page.dataset.ready = 'true';
    const form = page.querySelector('[data-tmo-product-form]');
    const variants = [...page.querySelectorAll('[data-tmo-variant]')];
    const submit = page.querySelector('[data-atc]');
    const submitLabel = page.querySelector('[data-atc-label]');
    const sticky = page.querySelector('[data-tmo-sticky]');
    const stickyButton = page.querySelector('[data-sticky-atc]');
    const stickyLabel = page.querySelector('[data-sticky-label]');

    const update = (radio) => {
      if (!radio) return;
      const price = radio.dataset.price || '';
      const available = radio.dataset.available === 'true';
      page.querySelectorAll('[data-price],[data-sticky-price]').forEach((node) => { node.textContent = price; });
      page.querySelectorAll('.tmo-bundle').forEach((card) => card.classList.toggle('is-selected', card.contains(radio)));
      if (submit) submit.disabled = !available;
      if (stickyButton) stickyButton.disabled = !available;
      if (submitLabel) submitLabel.textContent = available ? 'Add to cart' : 'Sold out';
      if (stickyLabel) stickyLabel.textContent = available ? 'Add to cart' : 'Sold out';
    };

    variants.forEach((radio) => radio.addEventListener('change', () => update(radio)));
    update(variants.find((radio) => radio.checked) || variants.find((radio) => !radio.disabled));

    stickyButton?.addEventListener('click', () => {
      if (!submit?.disabled) submit?.click();
    });

    page.querySelectorAll('[data-tmo-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      const image = page.querySelector('[data-tmo-main-image]');
      if (!image || !thumb.dataset.src) return;
      image.src = thumb.dataset.src;
      image.srcset = '';
      image.alt = thumb.dataset.alt || image.alt;
      page.querySelectorAll('[data-tmo-thumb]').forEach((item) => {
        item.classList.toggle('is-active', item === thumb);
        if (item === thumb) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
    }));

    if (sticky && form && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-active', !entry.isIntersecting), { threshold: 0 });
      observer.observe(form);
    }
  });

  const run = () => init(document);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
